<template>
	<v-card class="rating elevation-0 mb-2">
		<v-card-title class="rating__name">
			{{ rating.rating_name }}
		</v-card-title>
		<div
			class="rating__content"
			v-bind:style="{ justifyContent: ratingIsVoted ? 'space-between' : 'center' }"
		>
			<span v-if="ratingIsVoted" class="rating__total">{{ ratingTotal }} </span>
			<v-rating
				color="#FFBC03"
				:size="isLessThan600 ? 22 : 44"
				:ripple="false"
				v-model="value"
				:readonly="ratingIsVoted"
				:half-increments="ratingIsVoted"
			/>
			<span v-if="ratingIsVoted" class="rating__count">{{ ratingCount }}&nbsp;total </span>
		</div>
	</v-card>
</template>
<script>
export default {
	props: {
		rating: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			value: 0,
		}
	},
	computed: {
		ratingIsVoted() {
			return !!this.rating.vote
		},
		ratingTotal() {
			if (this.rating) {
				return this.rating.rating_total
			}
		},
		ratingCount() {
			if (this.rating) {
				return this.rating.rating_count
			}
		},
		isLessThan600() {
			return this.$vuetify.breakpoint.width <= 600
		},
	},
	watch: {
		value(newValue) {
			if (!this.rating.vote) {
				this.$emit('ratingChange', { rating_id: this.rating.rating_id, rating: newValue })
			}
		},
	},
	created() {
		if (this.rating.vote) {
			this.value = this.rating.rating_total
		}
	},
}
</script>
<style lang="scss">
.rating {
	background-color: #f3f3f6 !important;
	border: 1px solid #e2e2e2 !important;
	border-radius: 10px !important;
	padding: 16px;
	margin-bottom: 12px;
	font-family: Inter, sans-serif;

	&__content {
		display: flex;
		flex-wrap: nowrap;
		align-items: center;
	}

	&__name {
		font-size: 18px;
		font-weight: 700;
		color: var(--accent-color);
		line-height: 21.94px;
		padding: 0 !important;
		display: flex;
		justify-content: center;
	}

	&__total {
		font-family: Inter, sans-serif;
		font-weight: 700;
		font-size: 24px;
		line-height: 100%;
		letter-spacing: 0;
		color: var(--accent-color);

		@media (max-width: 480px) {
			font-size: 16px;
		}
	}

	&__count {
		font-family: Inter, sans-serif;
		font-weight: 500;
		font-size: 16px;
		line-height: 100%;
		letter-spacing: 0;
		text-align: right;
		color: #9b9b9b;

		@media (max-width: 480px) {
			font-size: 12px;
		}
	}

	.v-rating {
		display: flex;
		flex-wrap: nowrap;
		justify-content: center;
	}

	.accent--text::before {
		color: #e2e2e2 !important;
	}
}
</style>
